module.exports = __webpack_public_path__ + "media/images/banner-kuwait-c40042a9cf651234f40a7b3d1caa335b.jpg";